<template>
    <div class="signup-page">
        <div class="container">
            <div v-if="errors.length > 0"
                 style="background-color: rgba(255,116,116,0.56); border: #ff0e00 solid 2px; padding: 8px">
                <ul style="padding: revert; margin: revert">
                    <li style="list-style: square" v-for="error in errors"> {{ error }}</li>
                </ul>
            </div>
            <div v-if="successes.length > 0"
                 style="background-color: rgba(141,255,116,0.56); border: #00ff04 solid 2px; padding: 8px">
                <ul style="padding: revert; margin: revert">
                    <li style="list-style: square" v-for="success in successes"> {{ success }}</li>
                </ul>
            </div>
            <div class="row justify-content-between">
                <div class="col-md-8">
                    <div class="row  gx-5 justify-content-between">
                        <div class="col-md-5 col-sm-5">
                            <h1>{{ $t('login') }}</h1>

                            <div class="forms-style-1">

                                <div class="row">
                                    <div class="col-md-12">
                                        <form :action="$store.state.hrefPrefix + '/account/login'" method="post"
                                              @submit.prevent="" ref="login">
                                            <div class="row justify-content-between">
                                                <input type="hidden" name="_token" :value="csrf">
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="input-row">
                                                        <label>{{ $t('email') }}</label>
                                                        <input type="text" :placeholder="$t('email')" name="email"/>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="input-row">
                                                        <label>{{ $t('password') }}</label>
                                                        <input id="login_password" type="password"
                                                               :placeholder="$t('password')" name="password"/>
                                                        <span toggle="#login_password"
                                                              class="fa fa-fw fa-eye field-icon toggle-password"></span>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="forgot-password">
                                                        <a :href="$store.state.hrefPrefix + '/forget-password'">{{ $t('forgot_password') }}</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 col-12">
                                                    <div class="submit-btn">
                                                        <input class="g-recaptcha"
                                                               data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                                               data-callback="submitLogin" type="button"
                                                               value="Login"/>
                                                    </div>
                                                </div>
                                                <div v-if="$store.state.language.code === 'en'" class="col-md-12 col-12" style="margin-top: 10px; margin-bottom: 10px; text-align: right">
                                                    <a target="_blank" href="/google/redirect" class="btn-165">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 262">
                                                            <path fill="#4285F4"
                                                                  d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"></path>
                                                            <path fill="#34A853"
                                                                  d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"></path>
                                                            <path fill="#FBBC05"
                                                                  d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"></path>
                                                            <path fill="#EB4335"
                                                                  d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"></path>
                                                        </svg>
                                                        <span>Login with Google</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-2 col-sm-2"></div>
                        <div class="col-md-5 col-sm-4">
                            <h1>{{ $t('register') }} </h1>

                            <div class="forms-style-1">
                                <div class="row">
                                    <div class="col-md-12">
                                        <form :action="$store.state.hrefPrefix + '/account/register'" method="post"
                                              ref="register">
                                            <input type="hidden" name="_token" :value="csrf">
                                            <div class="row justify-content-between">
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="input-row">
                                                        <label>{{ $t('name') }}</label>
                                                        <input type="text" :placeholder="$t('name')" name="name"/>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="input-row">
                                                        <label>{{ $t('email') }}</label>
                                                        <input type="text" :placeholder="$t('email')" name="email"/>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="input-row">
                                                        <label>{{ $t('password') }} </label>
                                                        <input id="register_password" type="password"
                                                               :placeholder="$t('password')" name="password"/>
                                                        <span toggle="#register_password"
                                                              class="fa fa-fw fa-eye field-icon toggle-password"></span>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="input-row">
                                                        <label>{{ $t('repeat_password') }} </label>
                                                        <input id="register_password_repeat" type="password"
                                                               :placeholder="$t('password')" name="repeat_password"/>
                                                        <span toggle="#register_password_repeat"
                                                              class="fa fa-fw fa-eye field-icon toggle-password"></span>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="submit-btn">
                                                        <input class="g-recaptcha"
                                                               data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                                               data-callback="submitRegister" type="button"
                                                               :value="$t('register')"/>
                                                    </div>
                                                </div>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <!--                        <div class="col-md-7 col-sm-7">-->
                        <!--                            <div class="media-account">-->
                        <!--                                <div class="media-account-row">-->
                        <!--                                    <p>Use your social media account to sign in</p>-->
                        <!--                                    <span>We won’t post to any of your accounts without asking first</span>-->
                        <!--                                    <ul>-->
                        <!--                                        <li>-->
                        <!--                                            <i><img src="/assets/images/gmail-icon.svg" alt=""/></i>-->
                        <!--                                            <p>Sign in with Google</p>-->
                        <!--                                        </li>-->
                        <!--                                        <li>-->
                        <!--                                            <i><img src="/assets/images/fb-icon.svg" alt=""/></i>-->
                        <!--                                            <p>Sign in with Facebook</p>-->
                        <!--                                        </li>-->
                        <!--                                    </ul>-->
                        <!--                                </div>-->
                        <!--                                <span class="already_account">Already have an account? <a href="#">Log in</a></span>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
let errors = [];
if (typeof pageErrors !== 'undefined') {
    errors = pageErrors;
}

let successes = [];
if (typeof pageSuccesses !== 'undefined') {
    successes = pageSuccesses;
}


export default {
    name: "LoginPage",
    components: {},
    props: {},

    data() {
        return {
            errors: errors,
            successes: successes,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        submitLogin(response) {
            console.log(response)
            const form = this.$refs.login;
            form.submit();
        },
        submitRegister(response) {
            console.log(response)
            const form = this.$refs.register;
            form.submit();
        }
    },
    mounted() {
        window.submitLogin = this.submitLogin;
        window.submitRegister = this.submitRegister;
    }
}
</script>

<style scoped>
.btn-165 {
    padding: 10px 25px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
    border-radius: 0.5rem;
    border: 1px solid #bebebe;
    gap: 10px;
    color: #414141;
    background: #fff;
    font-family: Arial, Helvetica, sans-serif;
    cursor: pointer;
    text-decoration: none;
    user-select: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    /*** full width block ***/
    /* width: 100%; */
}

.btn-165 svg {
    height: 24px;
}

.btn-165:hover {
    border: solid 1px #464545;
}

.btn-165:active {
    margin-top: 1px;
}

/*** disabled style ***/
.btn-165:disabled {
    pointer-events: none;
    opacity: .65;
    color: #7e7e7e;
    background: #dcdcdc;
    box-shadow: none;
    text-shadow: none;
}


</style>
